var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "viewBox": "0 0 1.5 1.5",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "id": "Overview",
      "fill": "none",
      "fill-rule": "evenodd",
      "stroke-linecap": "round",
      "stroke-width": ".17599",
      "stroke": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "d": "m1.4104 0.58164v0.65367c0 0.097194-0.078792 0.17599-0.17599 0.17599h-0.96793c-0.097195 0-0.17599-0.078792-0.17599-0.17599v-0.96793c0-0.097195 0.078792-0.17599 0.17599-0.17599h0.65367",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "m1.3224 0.26738c0.048598 0 0.087994-0.039396 0.087994-0.087994 0-0.048597-0.039396-0.087994-0.087994-0.087994s-0.087994 0.039396-0.087994 0.087994c0 0.048598 0.039396 0.087994 0.087994 0.087994z"
    }
  }), _c('path', {
    attrs: {
      "d": "m0.4425 0.97133 0.26398-0.35197 0.17606 0.17599 0.26391-0.35197",
      "stroke-linejoin": "round"
    }
  })])]);

}
var staticRenderFns = []

export { render, staticRenderFns }